"use client";
import { useState, useEffect } from "react";
import { Wrap, WrapItem, Box, Stack } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { Heading, Text, Button } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { VENDORS_LIST, VENDORS_CONSTANTS } from "./constants"; // your vendor list

const VendorsTabs = ({ activeVendor }) => {
  const [selectedVendor, setSelectedVendor] = useState(activeVendor);
  const headingVariant = useHeadingVariant();
  useEffect(() => {
    setSelectedVendor(activeVendor);
  }, [activeVendor]);

  return (
    <Stack p={4} gap={10} id="vendors-tabs">
      <Heading as="h1" variant={headingVariant} textAlign={"center"}>
        {VENDORS_CONSTANTS.title}
      </Heading>
      <Balancer>
        <Text variant={"label1"} color={"text.100"} textAlign={"center"}>
          {VENDORS_CONSTANTS.desc}
        </Text>
      </Balancer>
      <Wrap gap={3}>
        {VENDORS_LIST.map((vendor) => (
          <WrapItem key={vendor.key}>
            <Button
              onClick={() => setSelectedVendor(vendor.key)}
              variant="outline"
              borderWidth="1px"
              borderColor={selectedVendor === vendor.key ? "black" : "gray.300"}
              bg={selectedVendor === vendor.key ? "primary.200" : "white"}
              color={selectedVendor === vendor.key ? "white" : "black"}
              _hover={{
                bg: selectedVendor === vendor.key ? "primary.200" : "gray.100",
              }}
              py={6}
              borderRadius="40px"
              minW="180px"
              textAlign="center"
            >
              {vendor.label}
            </Button>
          </WrapItem>
        ))}
      </Wrap>

      <Box>
        {VENDORS_LIST.map(
          (vendor) => selectedVendor === vendor.key && <vendor.comp key={vendor.key} />
        )}
      </Box>
    </Stack>
  );
};

export default VendorsTabs;
